import { Chart } from 'chart.js';
import { ChartOptions } from 'chart.js';

function cssVar(name: string): string {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}

export class SimpleChartOptions {
  private static getTimeUnit(
    timePeriod: string
  ): 'hour' | 'day' | 'week' | 'month' {
    switch (timePeriod) {
      case 'hour':
        return 'hour';
      case 'day':
        return 'day';
      case 'week':
        return 'week';
      case 'month':
        return 'month';
      default:
        return 'day';
    }
  }

  public static getOptions(
    timePeriod: string,
    dateFormat: string
  ): ChartOptions<'line'> {
    const timeUnit = this.getTimeUnit(timePeriod);
    
    const isDarkMode = document.documentElement.classList.contains('my-app-dark');
    
    const text = isDarkMode ? (cssVar('--chart-text') || '#6b7280') : '#6b7280';
    const grid = isDarkMode ? (cssVar('--chart-grid') || 'rgba(255,255,255,0.15)') : 'rgba(0, 0, 0, 0.1)';
    const ttBg = cssVar('--chart-tooltip-bg') || '#ffffff';
    const ttText = cssVar('--chart-tooltip-text') || '#000000';

    return {
      responsive: false,
      maintainAspectRatio: false,
      animation: false,
      interaction: {
        mode: 'index',
        intersect: false,
      },
      elements: {
        line: {
          tension: 0.4,
          cubicInterpolationMode: 'monotone',
        },
        point: {
          radius: 0,
          hoverRadius: 4,
          hitRadius: 8,
        },
      },
      ...(isDarkMode && { color: text }), // Only set color in dark mode
      scales: {
        x: {
          type: 'time',
          time: {
            unit: timeUnit,
            displayFormats: {
              hour: 'MMM dd, HH:mm',
              day: 'MMM dd',
              week: 'MMM dd',
              month: 'MMM yyyy',
            },
            tooltipFormat: dateFormat,
          },
          grid: {
            display: true,
            color: grid,
          },
          ticks: {
            display: false,
          },
        },
        y: {
          beginAtZero: false,
          grid: {
            display: true,
            color: grid,
          },
          ticks: {
            color: text,
          },
          title: {
            display: false,
          },
        },
      },
      plugins: {
        decimation: {
          enabled: true,
          algorithm: 'lttb' as const,
          samples: 200,
          threshold: 100,
        },
        tooltip: {
          backgroundColor: ttBg,
          titleColor: ttText,
          bodyColor: ttText,
        },
        legend: {
          display: false,
        },
      },
    };
  }
}
